// eslint-disable-next-line consistent-return
const getDataht = (key) => {
  const isDev = window.location.host.includes('develop') || window.location.host.includes('localhost');
  const src = isDev ? 'https://develop.omahapro.com/api/lang/tips' : 'https://omahapro.com/api/lang/tips';
  try {
    const response = fetch(
      src,
      {
        headers: {
          'Accept-Language': key,
        },
      },
    ).then((data) => data.json()).then((res) => res);

    return response;
  } catch (e) {
    console.log(e);
  }
};

export default getDataht;
